<template>
  <el-card class="h-full flex flex-col" :body-style="{ padding: '20px', height: '100%' }">
    <el-page-header :content="title" @back="back"> </el-page-header>
    <el-collapse
      v-model="activeName"
      class="mt-20px overflow-auto border"
      style="height: calc(100% - 108px)"
    >
      <el-form label-width="150px" :model="formData" ref="form" :rules="rules">
        <el-collapse-item title="指标信息" name="1">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="依赖指标" prop="dependMetricsIds">
                <el-select
                  placeholder="请选择"
                  v-model="formData.dependMetricsIds"
                  @change="changeDependMetricsIds"
                  clearable
                  filterable
                  class="!w-full"
                >
                  <el-option
                    v-for="(item, index) in dependMetricsList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="指标域" prop="metricsDmainId">
                <el-select
                  placeholder="请选择"
                  v-model="formData.metricsDmainId"
                  clearable
                  filterable
                  :filter-method="searchMetricsDmain"
                  class="!w-full"
                  popper-class="tag_select-popper"
                  ref="selectMetrics"
                  @clear="clearMetricsDmainId"
                >
                  <el-option :label="metricsDmainName" :value="formData.metricsDmainId">
                    <el-tree
                      :data="treeData"
                      :props="{
                        children: 'child',
                        label: 'name',
                      }"
                      node-key="id"
                      :current-node-key="currentNodeKey"
                      ref="tree"
                      @node-click="handleNodeClick"
                      default-expand-all
                    >
                    </el-tree> </el-option
                ></el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="指标名称" prop="name">
                <el-input placeholder="请输入" v-model="formData.name" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="指标编码" prop="code">
                <el-input
                  placeholder="请输入"
                  v-model="formData.code"
                  clearable
                  :disabled="type === 'update'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="计算信息" name="2">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="派生维度" prop="derivedDimensionsIds">
                <el-tooltip
                  placement="top"
                  content="请先选择依赖指标"
                  :disabled="formData.dependMetricsIds !== ''"
                >
                  <el-select
                    placeholder="请选择"
                    v-model="formData.derivedDimensionsIds"
                    @change="changeDerivedDimensionsIds"
                    clearable
                    filterable
                    class="!w-full"
                    :disabled="!formData.dependMetricsIds"
                    multiple
                  >
                    <el-option
                      v-for="(item, index) in dimensionList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="时间维度" prop="timeDimensionId">
                <el-tooltip
                  placement="top"
                  content="请先选择依赖指标"
                  :disabled="formData.dependMetricsIds !== ''"
                >
                  <el-select
                    placeholder="请选择"
                    v-model="formData.timeDimensionId"
                    clearable
                    filterable
                    class="!w-full"
                    :disabled="!formData.dependMetricsIds"
                  >
                    <el-option
                      v-for="(item, index) in timeDmensionList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="时间周期" prop="timeCycle">
                <el-tooltip
                  placement="top"
                  content="请先选择时间维度"
                  :disabled="formData.timeDimensionId !== ''"
                >
                  <el-select
                    placeholder="请选择"
                    v-model="formData.timeCycle"
                    clearable
                    filterable
                    :disabled="!formData.timeDimensionId"
                    class="!w-full"
                  >
                    <el-option
                      v-for="(item, index) in timeCycleList"
                      :key="index"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计算逻辑" prop="logic">
                <el-select
                  placeholder="请选择"
                  v-model="formData.logic"
                  clearable
                  filterable
                  class="!w-full"
                >
                  <el-option
                    v-for="(item, index) in logicList"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计算维度" prop="logicDimensionId">
                <el-tooltip
                  placement="top"
                  content="请先选择计算逻辑"
                  :disabled="formData.logic !== ''"
                >
                  <el-select
                    placeholder="请选择"
                    v-model="formData.logicDimensionId"
                    clearable
                    filterable
                    class="!w-full"
                    :disabled="formData.logic !== 4"
                  >
                    <el-option
                      v-for="(item, index) in dimensionList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="筛选维度" name="3">
          <div class="h-100px overflow-auto">
            <el-row class="flex mb-10px" v-for="(item, index) in filterDimensions" :key="index">
              <el-select
                placeholder="请选择维度"
                v-model="item.id"
                clearable
                filterable
                class="w-200px"
                @change="changeFilterDmension(item.id, index)"
              >
                <el-option
                  v-for="(fItem, fIndex) in filterDmensionList"
                  :key="fIndex"
                  :label="fItem.name"
                  :value="fItem.id"
                  :disabled="fItem.disabled"
                ></el-option>
              </el-select>
              <el-select
                v-if="item.isReference"
                placeholder="请选择"
                v-model="item.name"
                clearable
                filterable
                multiple
                class="w-200px ml-10px mr-10px"
              >
                <el-option
                  v-for="(fItem, fIndex) in item.referenceList"
                  :key="fIndex"
                  :label="fItem.name"
                  :value="fItem.id"
                ></el-option>
              </el-select>
              <el-input
                v-else
                placeholder="请输入"
                v-model="item.name"
                clearable
                class="w-200px ml-10px mr-10px"
              ></el-input>
              <el-button
                type="primary"
                @click="handleDimensions('add')"
                class="iconfont icon-line-add"
              ></el-button>
              <el-button type="primary" @click="handleDimensions('subtract', item)">一</el-button>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item title="计算结果" name="4">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="试计算">
                <el-button
                  type="primary"
                  class="iconfont icon-bg-circlePlay"
                  @click="startCalculation"
                  :loading="calcuaLoading"
                  >开始计算</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="调度信息">
                <el-tooltip
                  placement="top"
                  content="请先配置指标信息和计算信息"
                  :disabled="isDispatchConfig"
                >
                  <span>
                    <el-button
                      type="primary"
                      @click="taskSchedialogVisible = true"
                      :disabled="!isDispatchConfig"
                      >调度配置</el-button
                    >
                  </span>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="mb-20px flex items-center text-12px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-14px">语句预览</span>
          </div>
          <div class="overflow-x-auto">
            <codemirror
              ref="myCm"
              v-model="sqlExpression"
              :options="cmOptions"
              class="h-full sqlexpression"
            ></codemirror>
          </div>
          <div class="h-300px mt-10px flex">
            <ul class="h-300px w-60px write-vertical-left flex text-14px border divide-y">
              <li
                class="h-150px flex justify-center items-center bg-gray-100"
                v-for="(item, index) in tabList"
                :key="index"
                @click="changeTab(item.value)"
                :class="currentTab === item.value ? 'main-color' : ''"
              >
                {{ item.name }}
              </li>
            </ul>
            <div class="flex-1 ml-10px">
              <el-table
                v-if="currentTab === 2"
                :data="resultData"
                width="100%"
                height="300"
                border
                stripe
              >
                <el-table-column
                  v-for="(val, key, index) in tableHeader"
                  :prop="key"
                  :label="val"
                  :key="index"
                  show-overflow-tooltip
                >
                </el-table-column>
              </el-table>
              <div v-else class="w-full h-300px border">
                <div class="h-full border overflow-auto p-10px">
                  <div v-for="(item, index) in runLogMsg" :key="index">
                    {{ item.time }},{{ item.runLogMsg }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-form>
    </el-collapse>
    <div class="mt-20px text-center">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="back">取消</el-button>
    </div>

    <!-- 调度配置 -->
    <el-dialog
      title="调度配置"
      :visible.sync="taskSchedialogVisible"
      class="mid-dialog"
      v-dialogDrag
      :close-on-click-modal="false"
      v-if="taskSchedialogVisible"
    >
      <div>
        <span class="mr-10px">有效日期:</span>
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </div>
      <cron v-model="schedulingCron" ref="cron" class="h-full w-full mt-10px"></cron>
      <div class="text-center" slot="footer">
        <el-button type="primary" size="small" @click="saveCron"> 保存 </el-button>
        <el-button size="small" @click="taskSchedialogVisible = false"> 取消 </el-button>
      </div>
    </el-dialog>

    <!-- 编辑的提示弹窗 -->
    <el-dialog
      title="提示！"
      :visible.sync="visiable"
      class="small-dialog"
      v-dialogDrag
      :close-on-click-modal="false"
    >
      <div class="text-16px">编辑后会导致已发布的指标数据无法展示及关联指标无法引用！</div>
      <div class="text-16px mt-10px">关联指标如下：</div>
      <div class="mt-10px overflow-auto">
        <div class="mt-5px text-color" v-for="(value, key, index) in errMsg" :key="index">
          <span>【{{ value.asName }}】</span>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="visiable = false">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { codemirror } from 'vue-codemirror'
import MetricsManagementService from '@/services/MetricsManagementService'
import cron from '@/components/inferenceEngine/cron'

export default {
  name: 'DerivedMetrics',
  components: { cron, codemirror },
  data() {
    return {
      activeName: ['1', '2', '3', '4'],
      formData: {
        name: '',
        code: '',
        dependMetricsIds: '',
        metricsDmainId: '',
        derivedDimensionsIds: [],
        timeDimensionId: '',
        timeCycle: '',
        logic: '',
        dataModelId: '',
        cronExpression: '', // cron表达式
        scheduleStartTime: '', // 调度开始时间
        scheduleEndTime: '', // 调度结束时间
        logicDimensionId: null,
      },
      rules: {
        name: [{ required: true, message: '请输入指标名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入指标编码', trigger: 'blur' }],
        dependMetricsIds: [{ required: true, message: '请选择依赖指标', trigger: 'change' }],
        metricsDmainId: [{ required: true, message: '请选择指标域', trigger: 'change' }],
        derivedDimensionsIds: [{ required: true, message: '请选择派生维度', trigger: 'change' }],
        timeDimensionId: [{ required: true, message: '请选择时间维度', trigger: 'change' }],
        timeCycle: [{ required: true, message: '请选择时间周期', trigger: 'change' }],
        logic: [{ required: true, message: '请选择计算逻辑', trigger: 'change' }],
      },
      filterDimensions: [
        {
          id: '',
          name: '',
          isReference: false,
          referenceList: [],
        },
      ], // 筛选维度
      tabList: [
        { name: '运行日志', value: 1 },
        { name: '结果预览', value: 2 },
      ],
      currentTab: 2,
      resultData: [],
      tableHeader: {},
      taskSchedialogVisible: false,
      schedulingCron: '',
      time: [],
      dependMetricsList: [], // 依赖指标
      metricsDmainName: '', // 指标域name
      currentNodeKey: '',
      treeData: [],
      title: '',
      type: '',
      dimensionList: [], // 派生维度列表
      timeDmensionList: [], // 时间维度列表
      timeCycleList: [], // 时间周期列表
      logicList: [], // 计算逻辑列表
      isCalculation: false, // 是否点击试计算
      isDispatchConfig: false, // 是否可配置调度信息
      runLogMsg: '', // 运行日志
      timer: '',
      isRunning: true,
      filterDmensionList: [], // 筛选维度
      sqlExpression: '', // SQL语句表达式
      cmOptions: {
        tabSize: 4,
        mode: 'text/x-sql',
        theme: 'base16-light',
        lineNumbers: true,
        lineWrapping: true,
        lineWiseCopyCut: true,
        showCursorWhenSelecting: true,
        matchBrackets: true,
        line: true,
        styleActiveLine: true,
        autoRefresh: true,
        connect: 'align',
        readOnly: true,
      },
      dimensionIdList: [],
      conversionSqlExpression: '',
      visiable: false,
      errMsg: {},
      calcuaLoading: false,
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        if (
          newVal.name &&
          newVal.code &&
          newVal.dependMetricsIds &&
          newVal.metricsDmainId &&
          newVal.derivedDimensionsIds.length > 0 &&
          newVal.timeDimensionId &&
          newVal.timeCycle !== '' &&
          newVal.logic !== ''
        ) {
          this.isDispatchConfig = true
        } else {
          this.isDispatchConfig = false
        }
      },
      deep: true,
    },
  },
  methods: {
    back() {
      this.$router.push(`./metrics-management?metricsDmainId=${this.formData.metricsDmainId}`)
    },
    // 新增或删除筛选维度
    handleDimensions(type, row) {
      if (type === 'add') {
        this.filterDimensions.push({
          id: '',
          name: '',
          isReference: false,
          referenceList: [],
        })
      } else {
        if (this.filterDimensions.length === 1) {
          this.$message.warning('请最少保留一条筛选维度信息')
          return
        }
        this.filterDimensions.splice(this.filterDimensions.indexOf(row), 1)
      }
    },
    changeTab(val) {
      this.currentTab = val
    },
    // 保存调度配置
    saveCron() {
      // if (this.time.length === 0) {
      //   this.$message.warning('有效日期不能为空')
      //   return
      // }
      this.formData.cronExpression = this.schedulingCron
      this.formData.scheduleStartTime = this.time[0]
      this.formData.scheduleEndTime = this.time[1]
      this.taskSchedialogVisible = false
    },
    // 获取依赖指标(原子指标)
    async getDependMetrics() {
      const res = await MetricsManagementService.getMetricsList({
        NameOrCode: '',
        Type: 0,
        IsPublish: true, // 已发布的指标
        CreatedUserName: '',
        Sorting: '',
        SkipCount: 0,
        MaxResultCount: 999,
      })
      if (res && res.code === 0 && res.data) {
        this.dependMetricsList = res.data
      }
    },
    // 根据关键字查询指标域
    async searchMetricsDmain(val) {
      const res = await MetricsManagementService.searchMetricsDmain({
        nameOrCode: val || '',
      })
      if (res && res.code === 0 && res.data) {
        this.treeData = res.data
        this.currentNodeKey = this.formData.metricsDmainId
        this.accordIdToName(this.treeData, this.currentNodeKey)
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentNodeKey)
        })
      }
    },
    // 根据指标域id查找name
    accordIdToName(data, id) {
      _.map(data, (item) => {
        if (item.id === id) {
          this.metricsDmainName = item.name
        } else if (item.id !== id && item.child && item.child.length > 0) {
          this.accordIdToName(item.child, id)
        }
      })
    },
    clearMetricsDmainId() {
      this.formData.metricsDmainId = ''
      this.metricsDmainName = ''
    },
    handleNodeClick(node) {
      this.formData.metricsDmainId = node.id
      this.metricsDmainName = node.name
      this.$refs.selectMetrics.handleClose()
    },
    // 查询派生维度列表(维度，时间)
    async queryDimensionList(id) {
      const res = await MetricsManagementService.queryMetricsDimensionList({
        metricsId: id,
      })
      if (res && res.code === 0 && res.data) {
        this.dimensionList = _.filter(res.data, (item) => {
          return _.includes([0, 2], item.type)
        })
      }
    },
    // 修改依赖指标
    changeDependMetricsIds(val) {
      this.formData.derivedDimensionsIds = []
      this.formData.timeDimensionId = ''
      this.formData.timeCycle = ''
      if (val) {
        this.queryDimensionList(val)
        this.getDataModelId(val)
      }
    },
    // 修改派生维度
    changeDerivedDimensionsIds(val) {
      this.timeDmensionList = []
      this.filterDmensionList = []
      _.map(this.dimensionList, (item) => {
        if (_.includes(val, item.id) && item.type === 2) {
          this.timeDmensionList.push(item)
        }
        if (_.includes(val, item.id)) {
          this.filterDmensionList.push(item)
        }
      })
    },
    // 修改筛选维度
    async changeFilterDmension(id, index) {
      // 已经选择过的维度不能再选择
      _.map(this.filterDmensionList, (item) => {
        const current = _.find(this.filterDimensions, ['id', item.id])
        if (current) {
          item.disabled = true
        } else {
          item.disabled = false
        }
        return item
      })
      // 判断当前实体属性是否有参考数据
      if (id) {
        let sourceFieldId = null
        _.map(this.filterDmensionList, (item) => {
          if (id === item.id) {
            sourceFieldId = item.sourceFieldId
          }
        })
        if (!sourceFieldId) return
        const list = await this.getDimensionReferenceData(sourceFieldId)
        if (list === null) {
          this.filterDimensions[index].isReference = false
        } else {
          this.filterDimensions[index].isReference = true
          this.filterDimensions[index].referenceList = list
        }
      }
    },
    // 获取维度参考数据
    async getDimensionReferenceData(id) {
      const res = await MetricsManagementService.getDimensionReferenceData(id)
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return null
    },
    // 获取时间周期列表
    async getTimeCycleList() {
      const res = await MetricsManagementService.getTimeCycleList()
      if (res && res.code === 0 && res.data) {
        this.timeCycleList = res.data
      }
    },
    // 获取计算逻辑列表
    async getLogicList() {
      const res = await MetricsManagementService.getLogicList()
      if (res && res.code === 0 && res.data) {
        this.logicList = res.data
      }
    },
    // 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.formData.cronExpression) {
            this.$message.warning('请先配置调度信息')
            return
          }
          if (!this.isCalculation) {
            this.$message.warning('请先进行试计算')
            return
          }
          const dimensionsList = this.handleDimensionInfo()
          if (this.type === 'update') {
            this.updateMetrics(dimensionsList)
          } else {
            this.addMetrics(dimensionsList)
          }
        }
      })
    },
    // 新增指标
    async addMetrics(dimensionsList) {
      const res = await MetricsManagementService.addMetrics({
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        dependMetricsIds: this.formData.dependMetricsIds,
        metricsDmainId: this.formData.metricsDmainId,
        type: 1, // 派生指标
        dimensions: dimensionsList,
        timeDimensionId: this.formData.timeDimensionId,
        timeCycle: this.formData.timeCycle,
        logic: this.formData.logic,
        cronExpression: this.formData.cronExpression,
        scheduleStartTime: this.formData.scheduleStartTime,
        scheduleEndTime: this.formData.scheduleEndTime,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
        sqlExpression: this.sqlExpression,
        conversionSqlExpression: this.conversionSqlExpression,
        logicDimensionId: this.formData.logicDimensionId,
      })
      if (res && res.code === 0) {
        this.$message.success('派生指标新增成功')
        this.back()
      }
    },
    // 编辑指标
    async updateMetrics(dimensionsList) {
      const res = await MetricsManagementService.updateMetrics({
        id: this.id,
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        dependMetricsIds: this.formData.dependMetricsIds,
        metricsDmainId: this.formData.metricsDmainId,
        type: 1, // 派生指标
        dimensions: dimensionsList,
        timeDimensionId: this.formData.timeDimensionId,
        timeCycle: this.formData.timeCycle,
        logic: this.formData.logic,
        cronExpression: this.formData.cronExpression,
        scheduleStartTime: this.formData.scheduleStartTime,
        scheduleEndTime: this.formData.scheduleEndTime,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
        sqlExpression: this.sqlExpression,
        conversionSqlExpression: this.conversionSqlExpression,
        logicDimensionId: this.formData.logicDimensionId,
      })
      if (res && res.code === 0) {
        if (res.details) {
          this.visiable = true
          this.errMsg = res.details
        } else {
          this.$message.success('派生指标修改成功')
          this.back()
        }
      }
    },
    // 开始计算
    startCalculation() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isCalculation = true
          this.getPreviewSql()
          this.startCompute()
        }
      })
    },
    // 获取预览sql
    async getPreviewSql() {
      console.log(Wiz, Wiz.AuthHooks, Wiz.AuthHooks.GetUserInfo(), '000')
      const dimensionsList = this.handleDimensionInfo()
      const res = await MetricsManagementService.getPreviewSql({
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        dependMetricsIds: this.formData.dependMetricsIds,
        metricsDmainId: this.formData.metricsDmainId,
        type: 1, // 派生指标
        dimensions: dimensionsList,
        timeDimensionId: this.formData.timeDimensionId,
        timeCycle: this.formData.timeCycle,
        logic: this.formData.logic,
        cronExpression: this.formData.cronExpression,
        scheduleStartTime: this.formData.scheduleStartTime,
        scheduleEndTime: this.formData.scheduleEndTime,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
        logicDimensionId: this.formData.logicDimensionId,
      })
      if (res && res.code === 0 && res.data) {
        this.sqlExpression = res.data
      }
    },
    // 获取模型id
    async getDataModelId(id) {
      const res = await MetricsManagementService.getMetrics(id)
      if (res && res.code === 0 && res.data) {
        this.formData.dataModelId = res.data.dataModelId
        this.dimensionIdList = res.data.dimensions
      }
    },
    // 处理维度信息
    handleDimensionInfo() {
      const dimensionsList = []
      _.map(this.formData.derivedDimensionsIds, (item) => {
        const currentRow = _.find(this.filterDimensions, ['id', item])
        let currentName = null
        if (currentRow) {
          if (typeof currentRow.name === 'object') {
            currentName = currentRow.name.join(',')
          } else {
            currentName = currentRow.name
          }
        } else {
          currentName = ''
        }
        const currentDimension = _.find(this.dimensionList, ['id', item])
        const currentId = _.find(this.dimensionIdList, ['dataModelDimensionId', item])
        dimensionsList.push({
          dataModelDimensionId: item,
          metricsDimensionId: currentId ? currentId.id : '',
          isReference: currentRow ? currentRow.isReference : false,
          filterValues: currentName,
          asCode: currentDimension ? currentDimension.code : '',
          asName: currentDimension ? currentDimension.name : '',
        })
      })
      return dimensionsList
    },
    // 开始计算
    async startCompute() {
      const dimensionsList = this.handleDimensionInfo()
      const res = await MetricsManagementService.startCompute({
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        dependMetricsIds: this.formData.dependMetricsIds,
        metricsDmainId: this.formData.metricsDmainId,
        type: 1, // 派生指标
        dimensions: dimensionsList,
        timeDimensionId: this.formData.timeDimensionId,
        timeCycle: this.formData.timeCycle,
        logic: this.formData.logic,
        cronExpression: this.formData.cronExpression,
        scheduleStartTime: this.formData.scheduleStartTime,
        scheduleEndTime: this.formData.scheduleEndTime,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
        id: this.id,
        logicDimensionId: this.formData.logicDimensionId,
      })
      if (res && res.code === 0 && res.data) {
        const firstTime = new Date().getTime() // 第一次加载的时间
        this.setTimer(firstTime, res.data)
      }
    },
    // 获取计算信息
    async getComputeInfo(key) {
      const res = await MetricsManagementService.getComputeInfo({ key })
      if (res && res.code === 0 && res.data) {
        this.conversionSqlExpression = res.data.conversionSqlExpression
        this.resultData = res.data.dataPreview
        this.tableHeader = res.data.dataHeader
        this.runLogMsg = _.map(res.data.runLogMsg, (item) => {
          item.runLogMsg = item.runLogMsg.replace(/\\/g, '')
          return item
        })
        // isRunning为false停止请求
        this.isRunning = res.data.runLogMsg.every((item) => {
          return item.isRunning
        })
      }
    },
    // 定时器(超过十分钟停止请求)
    setTimer(firstTime, key) {
      this.calcuaLoading = true
      this.timer = setInterval(() => {
        const currentTime = new Date().getTime() // 最新加载的时间
        if (currentTime - firstTime >= 10 * 60 * 1000 || !this.isRunning) {
          clearInterval(this.timer)
          this.calcuaLoading = false
        }
        this.getComputeInfo(key)
      }, 3000)
    },
    // 查询指标详情
    async getMetrics() {
      if (!this.id) return
      const res = await MetricsManagementService.getMetrics(this.id)
      if (res && res.code === 0 && res.data) {
        if (this.type === 'update') {
          _.assign(
            this.formData,
            _.pick(res.data, [
              'name',
              'code',
              'dataModelId',
              'metricsDmainId',
              'dependMetricsIds',
              'cronExpression',
              'scheduleStartTime',
              'scheduleEndTime',
              'timeDimensionId',
              'timeCycle',
              'logic',
              'logicDimensionId',
            ])
          )
        } else if (this.type === 'copy') {
          _.assign(
            this.formData,
            _.pick(res.data, [
              'dataModelId',
              'metricsDmainId',
              'dependMetricsIds',
              'cronExpression',
              'scheduleStartTime',
              'scheduleEndTime',
              'timeDimensionId',
              'timeCycle',
              'logic',
              'logicDimensionId',
            ])
          )
        }
        this.conversionSqlExpression = res.data.conversionSqlExpression
        this.schedulingCron = this.formData.cronExpression
        this.time[0] = this.formData.scheduleStartTime ? this.formData.scheduleStartTime : ''
        this.time[1] = this.formData.scheduleEndTime ? this.formData.scheduleEndTime : ''
        await this.queryDimensionList(this.formData.dependMetricsIds)
        await this.getDataModelId(this.formData.dependMetricsIds)
        // 过滤调dataModelDimensionId为空的派生维度（新增时后台加的，不是用户手动加的）
        const dimensions = _.filter(res.data.dimensions, (item) => {
          return item.dataModelDimensionId
        })
        this.formData.derivedDimensionsIds = _.map(dimensions, (item) => {
          return item.dataModelDimensionId
        })
        this.changeDerivedDimensionsIds(this.formData.derivedDimensionsIds)
        this.filterDimensions = []
        _.map(res.data.dimensions, async (item) => {
          let list = []
          if (item.isReference) {
            const currentField = _.find(this.filterDmensionList, ['id', item.dataModelDimensionId])
            if (currentField) {
              list = await this.getDimensionReferenceData(currentField.sourceFieldId)
            }
          }
          if (item.filterValues) {
            this.filterDimensions.push({
              id: item.dataModelDimensionId,
              name: item.isReference ? item.filterValues.split(',') : item.filterValues,
              isReference: item.isReference,
              referenceList: list,
            })
          }
        })
        if (this.filterDimensions.length === 0) {
          this.filterDimensions = [
            {
              id: '',
              name: '',
              isReference: false,
              referenceList: [],
            },
          ]
        }
      }
    },
  },
  async created() {
    this.type = this.$route.query.type
    if (this.type === 'add') {
      this.title = '新增派生指标'
      this.formData.metricsDmainId = this.$route.query.metricsDmainId
        ? this.$route.query.metricsDmainId
        : ''
      this.metricsDmainName = this.$route.query.metricsDmainName
        ? this.$route.query.metricsDmainName
        : ''
    } else if (this.type === 'update') {
      this.title = '编辑派生指标'
      this.id = this.$route.query.id
      await this.getMetrics()
    } else if (this.type === 'copy') {
      this.title = '复制派生指标'
      this.id = this.$route.query.id
      await this.getMetrics()
    }
    this.getDependMetrics()
    this.searchMetricsDmain()
    this.getTimeCycleList()
    this.getLogicList()
  },
  deactivated() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>

.main-color {
  background-color: var(--systemMainColor);
  color: var(--colorLumpText);
}
.el-popper.tag_select-popper .el-select-dropdown__item {
  height: 100% !important;
  padding: 0;
}

</style>
<style lang="scss">

.sqlexpression .cm-s-base16-light.CodeMirror {
  height: 50px !important;
}

</style>
